var styles = {"mediaItem":"MediaObject-module_mediaItem__1pFSb"};

export { styles as default };
//# sourceMappingURL=MediaObject.module.css.js.map
